import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components'
import { rem } from '@mantine/core'

export const cssCategoryItem = css`
  padding: 0.375rem 0.75rem;
  display: inline-flex;
  gap: 0.25rem;
  align-items: center;
  white-space: nowrap;
  background-color: ${theme.colors.gray100};
  backdrop-filter: blur(0.83rem);
  border-radius: 0.5rem;

  .hhg-icon {
    width: 1.25rem;
    height: 1.25rem;
    line-height: 0;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: center;
    }
  }

  .label {
    color: ${theme.colors.gray800};
    font-size: 0.875rem;
    line-height: 1.4;
    letter-spacing: -0.2px;
  }
`

export const StyledHomeDivider = styled.div`
  display: none;
  width: 100%;
  height: ${rem(12)};
  background-color: ${theme.colors.neutral50};
  border-bottom: 1px solid ${theme.colors.neutral100};

  ${MediaQueries.smbDown} {
    display: block;
  }
`
